const QUERY_KEYS = {
  ASSETS_CREATE: 'create assets',
  ASSETS_UPDATE: 'update assets',
  ASSETS_CATEGORIES: 'get assets categories',
  ASSETS_YEAR_PLANNER_ACTIVITIES: 'get assets activities',
  ORGANIZATION_YEAR_PLANNER_ACTIVITY_TEMPLATES: 'get organization year planner activity templates',
  ASSETS_YEAR_PLANNER_ACTIVITY: 'get assets activity',
  ASSETS_INFORMATION_CHOICES: 'get assets information choices',
  ASSETS_GET_SINGLE: 'get single asset data',
  ASSETS_GET_LIST: 'get list of assets',
  ASSET_RELATIONS_GET_LIST: 'get asset relations',
  ASSET_RELATIONS_GET_CATEGORIES: 'get asset relation categories',
  ASSET_RELATIONS_GET_TYPES: 'get asset relation types',
  PRICING_INFO: 'pricing_info',
  GET_USER_DATA: 'get_user_data',
  GET_USER_KPI: 'get_user_kpi',
  GET_WORKPLACE_TEMPLATE: 'get_workplace_template',
  CREATE_WORKPLACE_TEMPLATE: 'create_workplace_template',
  DELETE_WORKPLACE_TEMPLATE: 'delete_workplace_template',
  GET_ALL_WORKPLACES: 'get_all_workplaces',
  CREATE_WORKPLACE: 'create workplace',
  GET_WORKPLACE: 'get workplace',
  GET_WORKPLACE_TEMPLATE_VALUES: 'get workplace template values',
  SET_DEFAULT_WORKPLACE: 'set default workplace',
  GET_SINGLE_SELF_TEST: 'get self test data',
  GET_SELF_TEST_SELECTABLE_ASSETS: 'get self test selectable assets',
  GET_SELF_TEST_PROGRESS_INSTANCE: 'get self test progress instance',
  CREATE_SELF_TEST_PROGRESS: 'create self test progress instance',
  ANSWER_QUESTION: 'answer question',
  GET_RECOMMENDED_CONTENT: 'get recommended content for dashboard',
  GET_SELF_TEST_RESULT: 'finish test and get self test result',
  GET_SELF_TEST_RESULT_PROGRESS_DATA: 'get progress data after finishing test',
  EDIT_TEST_ANSWER: 'edit self test question answer',
  GET_ORGANIZATION_INFO: 'get organization info',
  GET_ORGANIZATION_PAYMENT_STAGE_INFO: 'get organization payment stage info',
  REMAINING_RETENTION_DAYS: 'remaining retention days',
  REMAINING_TRIAL_DAYS: 'remaining trial days',
  GET_STRIPE_URL: 'get stripe url',
  GET_FEATURE_FLAGS: 'get feature flags',
  TABLE_FILTER: 'table filter',
  GET_CURRENT_USER: 'get current user',
  GET_WORKPLACE_DOCUMENT: 'get workplace document',
  ASSET_CONTACTS_GET_SINGLE: 'get single asset contact',
  ASSET_CONTACTS_GET_CATEGORIES: 'get asset contact categories',
  GET_ALL_ASSET_TASKS_BY_OWNER: 'get all asset tasks by owner',
  GET_USER_ASSET_TASK_BY_ID: 'get user asset task by id',
  GET_ORGANIZATION_ASSET_TASK_BY_ID: 'get organization asset task by id',
  GET_ORGANIZATION_ASSET_TASK_KPI: 'get organization KPI',
  GET_ORGANIZATION_ASSET_FILTERS_DATA: 'get organization filters data',
  GET_OTP_METHODS: 'get otp methods',
  GET_OTP_DEVICE_INFO: 'get otp device info',
  GET_OTP_DEVICES_LIST_FOR_AUTH: 'get otp devices list for auth',
  GET_RISK_ANALYSES_ASSETS_BY_OWNER: 'get risk analysis assets by owner',
  GET_ASSETS_AVAILABLE_FOR_RISK_ANALYSIS: 'get assets available for risk analysis',
  GET_SINGLE_RISK_ANALYSIS: 'get single risk analysis',
  GET_SINGLE_RISK: 'get single risk',
  GET_ALL_ASSET_RISKS: 'get all asset risks',
  GET_ALL_ASSET_RISK_TASKS: 'get all asset risk tasks',
  GET_RISK_ANALYSIS_MATRIX: 'get risk analysis matrix',
  GET_ALL_INCIDENT_FOR_USER: 'get all incidents for user',
  GET_SINGLE_ORGANIZATION_ASSET_RISK_TASK: 'get single organization asset risk task',
  GET_ORGANIZATION_RISK_TASKS_KPI: 'get organization risk tasks KPI',
  GET_MANAGEMENT_REPORT: 'get management report',
  GET_STATISTICS_TEMPLATES_DASHBOARD: 'get_statistics_templates_dashboard',
  GET_STATISTICS_TEMPLATES_DASHBOARD_INSTANCES: 'get_statistics_templates_dashboard_instances',
  SIGNUP_REDIRECT_URL: 'signup redirect url',
  ACTION_TEMPLATES_GET_ALL: 'get all action templates',
  PROCESSING_ACTIVITIES_GET_ALL: 'get all processing activities',
  PROCESSING_ACTIVITIES_METRICS: 'get processing activities metrics',
  PROCESSING_ACTIVITIES_GET_DETAIL: 'get processing activity detail',
  PROCESSING_ACTIVITIES_GET_DRAFT: 'get processing activity draft',
  PROCESSING_ACTIVITIES_ROPA_CATEGORIES: 'get ropa categories',
  PROCESSING_ACTIVITIES_ASSET_PROCESSINGS: 'get processing activity asset processings',
  PROCESSING_ACTIVITIES_ASSET_PROCESSINGS_METRICS: 'get processing activity asset processings metrics',
  ROPA_REVIEWS_ACTIVE: 'get active ropa review',
  ROPA_REVIEWS_START_SUMMARY: 'get ropa review start summary',
  ROPA_REVIEWS_ASSETS: 'get ropa review assets',
  ROPA_REVIEWS_PROCESSING_REVIEW_DETAIL: 'get ropa processing review detail',
  ASSET_ROPA_MINE: 'get owner asset ropa list',
  ASSET_ROPA_MINE_METRICS: 'get owner asset ropa metrics',
  ASSET_ROPA_MINE_DETAIL: 'get owner asset ropa detail',
  ASSET_ROPA_WORKSPACE: 'get owner asset ropa workspace',
  ASSET_ROPA_AVAILABLE_PROCESSING_ACTIVITIES: 'get available processing activities for asset ropa',
  ASSET_ROPA_APA_DETAIL: 'get asset processing activity detail',
  DPIA_REQUEST_OPEN: 'open dpia need assessment request',
  DPIA_DETAIL: 'get dpia detail',
  DPIA_REVIEW_DETAIL: 'get dpia review detail',
  LIA_DETAIL: 'get lia detail',
};

export default QUERY_KEYS;
